// Performance optimizations: decoding=async on all images, intrinsic-size reservation
(function(){
  function applyOptimizations(){
    // Add decoding=async to all images that don't have it
    document.querySelectorAll('img:not([decoding])').forEach(function(img){
      img.setAttribute('decoding', 'async');
    });
    // Add contain-intrinsic-size to product media containers so layout is reserved before image decodes
    document.querySelectorAll('slideshow-slide.product-media-container').forEach(function(el){
      if (!el.style.containIntrinsicSize) {
        el.style.containIntrinsicSize = 'auto 320px auto 420px';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyOptimizations);
  else applyOptimizations();
  // Also apply after dynamic loads (variant change, quick-add, etc.)
  var mo = new MutationObserver(function(mutations){
    var hasNewImg = false;
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(n){
        if (n.nodeType === 1 && (n.tagName === 'IMG' || n.querySelector && n.querySelector('img'))) hasNewImg = true;
      });
    });
    if (hasNewImg) applyOptimizations();
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
